import PropTypes from "prop-types";
import classnames from "classnames";
import { SvgInline } from "../SvgInline/SvgInline";

import "./_chevron.scss";

function Chevron(props) {
  const { direction, className, ...otherProps } = props;

  return (
    <div
      aria-hidden="true"
      className={classnames("chevron", `chevron--${direction}`, className)}
    >
      <SvgInline {...otherProps} name="chevron" />
    </div>
  );
}

Chevron.propTypes = {
  direction: PropTypes.oneOf(["up", "right", "down", "left"]),
  className: PropTypes.string,
};

Chevron.defaultProps = {
  direction: "up",
};

export { Chevron };
